import React from 'react';
import { Alert, Button } from '@mui/material';
import LocalText from '../common/LocalText';
import { describeAnalyticsError } from '../../utils/analyticsMetrics';

/**
 * Slim error strip for one request. With numbers already on screen it says so and keeps them;
 * with nothing loaded yet it is the full "couldn't load" alert. A 403 gets its own wording and
 * no Retry (retrying cannot grant access).
 */
const AnalyticsErrorStrip = ({ error, hasData, what, onRetry }) => {
  if (!error) return null;
  const { kind, message } = describeAnalyticsError(error);

  if (kind === 'forbidden') {
    return <Alert severity="error" role="alert"><LocalText>{message}</LocalText></Alert>;
  }

  const text = kind === 'validation'
    ? message
    : hasData
      ? `Couldn't refresh ${what} — showing the last loaded numbers.`
      : `Couldn't load ${what}.`;

  return (
    <Alert
      severity={hasData ? 'warning' : 'error'}
      role="alert"
      action={onRetry && (
        <Button color="inherit" size="small" onClick={onRetry} sx={{ textTransform: 'none', fontWeight: 700 }}>
          <LocalText>Retry</LocalText>
        </Button>
      )}
    >
      <LocalText>{text}</LocalText>
    </Alert>
  );
};

export default AnalyticsErrorStrip;
